export const captchaKey = "6Lf7p4glAAAAALONs432DnkjPnCGCKXTdHGopY3H";
